import React from 'react'
import PageHeader from '../components/PageHeader'

const SkillCourse_Online = () => {
    return (
        <div>
            <PageHeader title="Skill Course Online" />
        </div>
    )
}

export default SkillCourse_Online